<template>
  <div class="echarts">
    <div class="homePage-center-title">
      <span class="center-title">平台重要指标走势</span>
    </div>
    <div class="center-echart">
      <line-chart :chart-data="echartLine" class="echart-item"></line-chart>
      <bar-chart :chart-data="echartBar" class="echart-item"></bar-chart>
    </div>

  </div>
</template>

<script>
import lineChart from "./lineChart";
import barChart from "./barChart";
import bus from "@/utils/BusEvent";
import { mapGetters } from "vuex";
export default {
  props: {},
  components: {
    lineChart,
    barChart
  },
  computed: {
    ...mapGetters([
      'echartLine',
      'echartBar'
    ])
  },
  data() {
    return {};
  },
  created() {}
};
</script>

<style lang="scss" scoped>
@import "../style/mixin";
@import "../style/_variables";

.homePage-center-title {
  @include flex-row;
  width: 100%;
  justify-content: space-between;
  height: $head-height;
  // background-color: $head-bg;
  padding: $head-padding;
  margin-top: 10px;
  > .center-title {
    padding-left: 10px;
    border-left: $border-left-31;
    font-size: $font-18;
    color: $color-52;
  }
  > .center-select {
    padding-right: 20px;
  }
}

.center-echart {
  width: 100%;
  height: 100%;
  @include flex-row;
  justify-content: space-around;
  > .echart-item {
    flex: 1;
    width: 368px;
    height: 368px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/echarts.vue